// package imports:
import React from "react";
// component imports:
import Entrypoint from "../Entrypoint";
import ViewIndividiualAnswers from "../../components/DueDiligence/ViewAnswers/ViewIndividualAnswers";
import { KnowYourIndividual, RiskScoreDto, ServiceCompanyEmployee } from "../../types/DueDiligenceTypes";

const ViewIndividiualAnswersEntry: React.FC<{ customerId: string; riskscoreId: string; riskscore: RiskScoreDto, answerListId: number, individual: KnowYourIndividual | null, employees: ServiceCompanyEmployee[] }> = ({
    customerId,
    riskscoreId,
    riskscore,
    answerListId,
    individual,
    employees
}) => {
    return (
        <Entrypoint>
            <ViewIndividiualAnswers
                customerId={customerId}
                riskscoreId={riskscoreId}
                riskscore={riskscore}
                answerListId={answerListId}
                individual={individual}
                employees={employees}
            />
        </Entrypoint>
    )
};

export default ViewIndividiualAnswersEntry;